import moment from 'moment';
import React from 'react';

class TimeLabel extends React.Component {
  render() {
    const { skipUtc, value } = this.props;

    if (!!value) {
      const date = skipUtc ? moment(value) : moment.utc(value);

      return <span>{date.format('h:mm a')}</span>;
    }

    return <span>{this.props.fallback}</span>;
  }
}

TimeLabel.defaultProps = {
  fallback: ''
};

export default TimeLabel;
